<template>
  <transition name="page">
    <div id="app" v-if="isAfterEnterAnimation">
      <Logo />
      <YisHeader />
      <transition name="router-view-anim" mode="out-in">
        <router-view :key="$route.meta.name + $route.params.slug" />
      </transition>
      <YisFooter />
      <Follow />
      <Cookies v-if="showCookiesOpen" />
      <!-- <transition name="shoow-cookies">
        <Cookies v-if="showCookiesOpen" />
      </transition> -->
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import Logo from "@/modules/Logo.vue";
// import Header from "@/modules/Header.vue";
// import Footer from "@/modules/Footer.vue";
// import Follow from "@/modules/Follow.vue";
// import Cookies from "@/modules/Cookies.vue";
const Logo = () => import(/* webpackChunkName: "Logo" */'@/modules/Logo.vue');
const YisHeader = () => import(/* webpackChunkName: "YisHeader" */'@/modules/YisHeader.vue');
const YisFooter = () => import(/* webpackChunkName: "YisFooter" */'@/modules/YisFooter.vue');
const Follow = () => import(/* webpackChunkName: "Follow" */'@/modules/Follow.vue');
const Cookies = () => import(/* webpackChunkName: "Cookies" */'@/modules/Cookies.vue');
export default {
  components: {
    Logo,
    YisHeader,
    YisFooter,
    Follow,
    Cookies
  },
  created() {
    //set global height
    document.documentElement.style.setProperty(
      "--vh",
      `${document.documentElement.clientHeight * 0.01}px`
    );
    //set cookies
    if (localStorage.getItem("cookies") != "true") {
      // this.setShowCookies(true);
      setTimeout(() => {
        this.setShowCookies(true);
      }, 8000);
    }
    //set window.history
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    //add listeners
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    //check is logo stock on top
    if (this.$route.meta.logo_on_top) {
      this.setLogoOnTop(true);
      this.setLogoOnlyOnTop(true);
    } else {
      this.setAfterEnterAnimation(false);
      if (window.pageYOffset < 80) {
        setTimeout(() => {
          this.setAfterEnterAnimation(true);
        }, 1000);
      } else {
        this.setAfterEnterAnimation(true);
        this.setLogoOnTop(true);
      }
    }
    //init check mobile size
    this.checkMobile();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  computed: mapGetters([
    "showMenuMobile",
    "isLogoOnTop",
    "showMenuOpen",
    "isAfterEnterAnimation",
    "isMobile",
    "isLogoOnlyOnTop",
    "showNavBar",
    "showCookiesOpen",
    "scrollPos"
  ]),
  methods: {
    ...mapActions([
      "setMenuMobile",
      "setMenuOpen",
      "setLogoOnTop",
      "setAfterEnterAnimation",
      "setNavBar",
      "setIsMobile",
      "setShowFilter",
      "setMenuSearch",
      "setSelectedFilters",
      "setSearchText",
      "setLogoOnlyOnTop",
      "setShowCookies",
      "toggleMenu",
      "setNewsletterOpen",
      "setScrollPos"
    ]),
    handleScroll() {
      if (document.getElementsByClassName("letter")) {
        Array.from(document.getElementsByClassName("letter")).map(el => {
          const offsetY = el.getBoundingClientRect().top;
          const screenHeight = window.innerHeight;
          const top = Math.floor((offsetY - screenHeight / 2) / 10);
          if (top < 200 && top > -200) {
            el.style.transform = `translateY(${top}px)`;
          }
        });
      }
      if (document.getElementsByClassName("before-anim")) {
        Array.from(document.getElementsByClassName("before-anim")).map(el => {
          if (this.elementInViewport(el, 400)) {
            el.classList.remove("before-anim");
            setTimeout(() => {
              el.classList.remove("anim");
            }, 2000);
          }
        });
      }
      if (document.getElementsByClassName("fade-in-anim")) {
        Array.from(document.getElementsByClassName("fade-in-anim")).map(el => {
          if (this.elementInViewport(el, 200)) {
            el.classList.remove("fade-in-anim-hide");
            setTimeout(() => {
              el.classList.remove("fade-in-anim");
            }, 1000);
          }
        });
      }
      if (document.getElementsByClassName("fade-in-anim-all")) {
        Array.from(document.getElementsByClassName("fade-in-anim-all")).map(
          el => {
            if (this.elementInViewport(el, 200)) {
              el.classList.remove("fade-in-anim-all-hide");
              setTimeout(() => {
                el.classList.remove("fade-in-anim-all");
              }, 1000);
            }
          }
        );
      }
      if (window.pageYOffset > window.innerHeight && !this.showNavBar) {
        this.setNavBar(true);
      } else if (window.pageYOffset <= window.innerHeight && this.showNavBar) {
        this.setNavBar(false);
      }
      if (!this.isMobile) {
        if (
          window.pageYOffset < 80 &&
          !this.showMenuOpen &&
          this.showMenuMobile
        ) {
          this.setMenuMobile(false);
        } else if (
          window.pageYOffset >= 80 &&
          !this.showMenuOpen &&
          !this.showMenuMobile
        ) {
          this.setMenuMobile(true);
        }
      }
      if (window.pageYOffset < 80 && !this.showMenuOpen && this.isLogoOnTop) {
        if (this.isLogoOnlyOnTop) {
          this.setLogoOnTop(true);
        } else {
          this.setLogoOnTop(false);
        }
      } else if (
        window.pageYOffset >= 80 &&
        !this.showMenuOpen &&
        !this.isLogoOnTop
      ) {
        this.setLogoOnTop(true);
      }
    },
    handleResize() {
      this.checkMobile();
      //set global height
      document.documentElement.style.setProperty(
        "--vh",
        `${document.documentElement.clientHeight * 0.01}px`
      );
    },
    checkMobile() {
      // if (window.innerWidth <= 1024 && !this.isMobile) {
      if (window.innerWidth <= 1340 && !this.isMobile) {
        this.setIsMobile(true);
        this.setMenuMobile(true);
        this.setMenuOpen(false);
      // } else if (window.innerWidth > 1024 && this.isMobile) {
      } else if (window.innerWidth > 1340 && this.isMobile) {
        this.setIsMobile(false);
        this.setMenuMobile(false);
        this.setMenuOpen(false);
      }
    },
    elementInViewport(el, offset) {
      var top = el.offsetTop + offset;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight + offset;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }

      return (
        top < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
      );
    },
  },
  watch: {
    $route(to) {
      this.setMenuOpen(false);
      this.setMenuSearch(false);
      this.setSearchText("");
      this.setShowFilter(null);
      this.setNewsletterOpen(false);
      if (!this.isMobile) {
        this.setMenuMobile(false);
      }
      if (to.meta.logo_on_top) {
        this.setLogoOnTop(true);
        this.setLogoOnlyOnTop(true);
      } else {
        this.setLogoOnTop(false);
        this.setLogoOnlyOnTop(false);
      }
    }
  },
};
</script>

<style lang="scss">
@import "~@/scss/_reset.scss";
@import "~@/scss/_fonts.scss";
@import "~@/scss/_typography.scss";
@import "~@/scss/_global.scss";
// @import "~@/scss/_cookiesconsent.scss";


.page-enter-active,
.page-leave-active {
  transition: none 3s;
  overflow: hidden;
  .main-header {
    transition: all 3s !important;
    transition-delay: 1s !important;
  }
}
.page-enter,
.page-leave {
  .main-header {
    opacity: 0;
  }
  .bottom-scroll {
    opacity: 0;
    &:after {
      transform: scaleY(0) !important;
    }
  }
  .follow {
    opacity: 0;
  }
  .filters-button-wrapper {
    opacity: 0;
  }
  .bordered-container:before {
    transform: translateY(100%);
    opacity: 0;
  }
  .header-bg-text {
    opacity: 0;
  }
}

.before-anim {
  &.want-to-find {
    .scroll {
      &:before {
        transform: scaleX(0) !important;
      }
    }
  }
}
.anim {
  &.want-to-find {
    .scroll {
      &:before {
        transition: transform 1s;
        transform-origin: 100% 50%;
        transform: scaleX(1);
      }
    }
  }
}

@media (min-width: $tablet) {
  .before-anim {
    .anim-box {
      .image {
        filter: grayscale(100%);
        &:before {
          transform: translateX(-102%) !important;
        }
        .bg {
          transform: translateX(-102%) !important;
        }
      }
      .text {
        opacity: 0 !important;
      }
    }
    &.good-design {
      &:before {
        transform: translateX(-100%) !important;
      }
      &:after {
        transform: translateX(100%) !important;
      }
    }
    &.want-to-find {
      .scroll {
        &:before {
          transform: scaleX(0) !important;
        }
      }
    }
    &.posts-page-posts {
      &:before {
        transform: translateX(-100%) !important;
      }
      &:after {
        transform: translateX(100%) !important;
      }
    }
    .scroll-to-next-section {
      &:after {
        transform: scaleX(0) !important;
      }
    }
  }
  .anim {
    &.latest-news,
    &.trending {
      .anim-box {
        .image {
          transition: all 3s cubic-bezier(0.23, 1, 0.32, 1) !important;
          transition-delay: 1s !important;
          will-change: filter;
          .bg {
            transition: all 3s cubic-bezier(0.23, 1, 0.32, 1) !important;
            transition-delay: 0.2s !important;
            will-change: transform;
          }
          &:before {
            transition: all 3s cubic-bezier(0.23, 1, 0.32, 1) !important;
            will-change: transform;
          }
        }
        .text {
          transition: all 3s !important;
          will-change: opacity;
        }
      }
    }
    .anim-box {
      pointer-events: none;
      .image {
        transition: all 2s cubic-bezier(0.23, 1, 0.32, 1) !important;
        transition-delay: 1s !important;
        will-change: filter;
        .bg {
          transition: all 2s cubic-bezier(0.23, 1, 0.32, 1) !important;
          transition-delay: 0.2s !important;
          will-change: transform;
        }
        &:before {
          transition: all 2s cubic-bezier(0.23, 1, 0.32, 1) !important;
          will-change: transform;
        }
      }
      .text {
        transition: all 2s !important;
        will-change: opacity;
      }
    }
    &.good-design {
      &:before {
        transform: translateX(0);
        transition: all 2s !important;
      }
      &:after {
        transform: translateX(0);
        transition: all 2s !important;
      }
    }
    &.want-to-find {
      .scroll {
        &:before {
          transition: transform 1s;
          transform-origin: 100% 50%;
          transform: scaleX(1);
        }
      }
    }
    .scroll-to-next-section {
      &:after {
        transition: transform 1s;
        transform-origin: 0% 50%;
        transform: scaleX(1);
        transition-delay: 1s;
      }
    }
    &.posts-page-posts {
      &:before {
        transform: translateX(0);
        transition: all 2s !important;
      }
      &:after {
        transform: translateX(0);
        transition: all 2s !important;
      }
    }
  }
}

.fade-in-anim-all {
  transition: opacity 1s !important;
  opacity: 1 !important;
  &.fade-in-anim-all-hide {
    opacity: 0 !important;
  }
}

@media (max-width: $tablet) {
  .fade-in-anim {
    transition: opacity 1s !important;
    opacity: 1 !important;
    &.fade-in-anim-hide {
      opacity: 0 !important;
    }
  }
}

.router-view-anim-enter-active,
.router-view-anim-leave-active {
  transition: opacity 0.5s;
}
.router-view-anim-enter,
.router-view-anim-leave-to {
  opacity: 0;
}
// .shoow-cookies-enter-active,
// .shoow-cookies-leave-active {
//   transition: transform 1s;
// }
// .shoow-cookies-enter,
// .shoow-cookies-leave-to {
//   transform: translateY(100%);
// }
</style>
